import { render, staticRenderFns } from "./DealGrid.vue?vue&type=template&id=546f983e&scoped=true&"
import script from "./DealGrid.vue?vue&type=script&lang=ts&"
export * from "./DealGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DealGrid.vue?vue&type=style&index=0&id=546f983e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f983e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
